module.exports = __webpack_public_path__ + "static/img/news23-1.7e7af91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news23-1.jpg
// module id = hgOX
// module chunks = 0